module.exports = __webpack_public_path__ + "img/img-case.eeb9fab8.png";